var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"back-btn"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.preventDefault();return _vm.back($event)}}},[_vm._v("Back")])])}
var staticRenderFns = []

export { render, staticRenderFns }